import React from 'react'
import styled from 'styled-components'
import { ImageField, NumberField, TextField } from '@sentecacommerce-theme/base'
import { Link } from '@sentecacommerce-theme/lib'
import { LazyImage } from '../Common'

export type TopMobileBannerProps = {
  image: ImageField
  url: TextField
  imageWidth: NumberField
  imageHeight: NumberField
  alt: TextField
}

export const TopMobileBanner = ({
  image,
  url,
  imageHeight,
  imageWidth,
  alt,
}: TopMobileBannerProps) => (
  <Link href={url} passHref>
    <TopMobileBannerContainer>
      <figure>
        <LazyImage
          width={imageWidth * 2}
          height={imageHeight * 2}
          src={image}
          alt={alt}
        />
      </figure>
    </TopMobileBannerContainer>
  </Link>
)

const TopMobileBannerContainer = styled.a.attrs({
  className: 'd-block d-lg-none',
})``
